export interface PortalBuild {
  component: 'portal';
  version: string;
  buildId: string;
  commitSha: string | null;
  builtAt: string;
  isLocal: boolean;
  environment: string;
  repositoryUrl?: string;
}

declare const __PORTAL_BUILD__: PortalBuild;

export const portalBuild: Readonly<PortalBuild> = Object.freeze(__PORTAL_BUILD__);